import React, { PureComponent, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Literal from 'components/literal';
import { ButtonPrimary } from 'components/buttons';
import './styles.scss';

/**
 * General component description.
 */
class AlertModal extends PureComponent {
    constructor(props) {
        super(props);

        this.rootSelector = document.getElementById('modal-root');
        this.el = document.createElement('div');
    }

    componentDidMount() {
        this.rootSelector.appendChild(this.el);
    }

    componentWillUnmount() {
        this.rootSelector.removeChild(this.el);
    }

    renderChildren() {
        const {
            isOpen,
            title = 'cfm_label_info',
            text = '',
            acceptText = 'cfm_action_accept',
            closeModal = () => null,
        } = this.props;
        const className = `alert-modal ${isOpen ? 'show' : ''}`;

        return (
            <Fragment>
                {isOpen && <div className="modal-overlay" />}
                <div className={className}>
                    <div className="alert-header">
                        <Literal literal={title} />
                    </div>
                    <div className="alert-content">
                        <div className="alert-text">
                            <Literal literal={text} />
                        </div>
                    </div>
                    <div className="alert-footer">
                        <ButtonPrimary onClick={closeModal} classNames={['dialog-footer-btn']}>
                            <Literal literal={acceptText} />
                        </ButtonPrimary>
                    </div>
                </div>
            </Fragment>
        );
    }

    render() {
        return ReactDOM.createPortal(this.renderChildren(), this.el);
    }
}

AlertModal.propTypes = {
    /** Indicate if modal is opened */
    isOpen: PropTypes.bool,
    /** Literal key for title */
    title: PropTypes.string,
    /** Literal key for Description */
    text: PropTypes.string,
    /** Literal key for cancel button */
    acceptText: PropTypes.string,
    /** Function to call when close modal */
    closeModal: PropTypes.func,
};

export default AlertModal;
